import React, {useState, useRef, useMemo, useEffect} from 'react'
import moment from 'moment'
import _ from 'lodash'

import {IconButton, Popover} from '@material-ui/core'
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft'
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight'

import './WeekView.scss'
import WeekDay from './WeekDay'

const WeekView = () => {
  const refScroll = useRef(null)
  const [week, setWeek] = useState(
    moment()
      .startOf('week')
      .add('day', 1)
  )

  const handleInitScroll = percHeight => {
    const rect = refScroll.current.getBoundingClientRect()
    refScroll.current.scrollTo(0, rect.height * percHeight)
  }

  const handleNextDay = () => {
    setWeek(week.clone().add(1, 'day'))
  }

  const handlePrevDay = () => {
    setWeek(week.clone().subtract(1, 'day'))
  }

  return (
    <div className="c-calendar-week">
      <div style={{display: 'flex', marginBottom: 18}}>
        <div className="c-calendar-week__column c-calendar-week__column--left">
          <div className="ap-flex ap-flex--end ap-flex--align-center">
            <IconButton size="small" className="c-res-mod ap-icon-button" onClick={handlePrevDay}>
              <KeyboardArrowLeftIcon />
            </IconButton>
          </div>
        </div>
        <div className="ap-flex">
          <div className="ap-flex ap-flex--center ap-flex--a-center ap-typography ap-typography--lg">
            {week.format('MMM DD')}
          </div>
          <div className="ap-flex ap-flex--center ap-flex--a-center ap-typography ap-typography--lg">
            {week
              .clone()
              .add(1, 'day')
              .format('MMM DD')}
          </div>
          <div className="ap-flex ap-flex--center ap-flex--a-center ap-typography ap-typography--lg">
            {week
              .clone()
              .add(2, 'day')
              .format('MMM DD')}
          </div>
          <div className="ap-flex ap-flex--center ap-flex--a-center ap-typography ap-typography--lg">
            {week
              .clone()
              .add(3, 'day')
              .format('MMM DD')}
          </div>
          <div className="ap-flex ap-flex--center ap-flex--a-center ap-typography ap-typography--lg">
            {week
              .clone()
              .add(4, 'day')
              .format('MMM DD')}
          </div>
        </div>
        <div className="c-calendar-week__column c-calendar-week__column--right">
          <div className="ap-flex ap-flex--start ap-flex--a-center">
            <IconButton size="small" className="c-res-mod ap-icon-button" onClick={handleNextDay}>
              <KeyboardArrowRightIcon />
            </IconButton>
          </div>
        </div>
      </div>
      <div style={{display: 'flex', height: 288}}>
        <div
          ref={refScroll}
          style={{display: 'flex', flex: 1, height: '100%', overflow: 'auto'}}
          className="ap-scrollbar"
        >
          <div className="c-calendar-week__scroll-wrapper">
            <div
              className="c-calendar-week__column c-calendar-week__column--left"
              style={{textAlign: 'center'}}
            >
              {Time.map(t => (
                <div className="c-calendar-week__time">
                  {t.h} {t.a}
                </div>
              ))}
            </div>
            <div className="c-calendar-week__grid-wrapper">
              {Array.from({length: 5}).map((c, i) => (
                <WeekDay
                  times={Time}
                  date={week.clone().add(i, 'day')}
                  onInitScroll={handleInitScroll}
                  disableDatesBefore={moment()}
                />
              ))}
            </div>
          </div>
        </div>
        <div className="ap-flex--start c-calendar-week__column c-calendar-week__column--left"></div>
      </div>
    </div>
  )
}

export default WeekView

const Time = [
  {h: 1, m: '00', a: 'am'},
  {h: 2, m: '00', a: 'am'},
  {h: 3, m: '00', a: 'am'},
  {h: 4, m: '00', a: 'am'},
  {h: 5, m: '00', a: 'am'},
  {h: 6, m: '00', a: 'am'},
  {h: 7, m: '00', a: 'am'},
  {h: 8, m: '00', a: 'am'},
  {h: 9, m: '00', a: 'am'},
  {h: 10, m: '00', a: 'am'},
  {h: 11, m: '00', a: 'am'},
  {h: 12, m: '00', a: 'pm'},
  {h: 1, m: '00', a: 'pm'},
  {h: 2, m: '00', a: 'pm'},
  {h: 3, m: '00', a: 'pm'},
  {h: 4, m: '00', a: 'pm'},
  {h: 5, m: '00', a: 'pm'},
  {h: 6, m: '00', a: 'pm'},
  {h: 7, m: '00', a: 'pm'},
  {h: 8, m: '00', a: 'pm'},
  {h: 9, m: '00', a: 'pm'},
  {h: 10, m: '00', a: 'pm'},
  {h: 11, m: '00', a: 'pm'},
  {h: 12, m: '00', a: 'am'},
]
